module.exports = __webpack_public_path__ + "static/FoundryGridnik-Medium-01565606898a81d5d649055d509284d1.woff2";